export enum BarAction {
    ACTION_COLLAPSE = 'COLLAPSE',
    ACTION_EXPAND = 'EXPAND'
}
